export function getQueryParamsMap() {
  return window.location.search
    .slice(1)
    .split('&')
    .reduce((paramsMap, param) => {
      const [key, value] = param.split('=', 2);
      return {...paramsMap, [key]: value};
    }, {});
}
